(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-photo-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.bd-photo-reviews:not([data-ready])');
    sections.forEach(async (section) => {
      section.dataset.ready = 'true';
      const grid = section.querySelector('[data-review-grid]');
      const loadMore = section.querySelector('[data-load-more]');
      const empty = section.querySelector('[data-empty-message]');
      const average = section.querySelector('[data-average-rating]');
      const total = section.querySelector('[data-review-total]');
      const popupAverage = section.querySelector('[data-popup-average]');
      const ratingDetails = section.querySelector('[data-rating-details]');
      const manualNode = section.querySelector('[data-manual-reviews]');
      const manualData = manualNode ? JSON.parse(manualNode.textContent) : { reviews: [] };
      const showDates = section.dataset.showDates === 'true';
      const showBadges = section.dataset.showBadges === 'true';
      const showMedia = section.dataset.showMedia === 'true';
      const pageSize = Number(section.dataset.pageSize) || 6;
      const usePreloaded = section.dataset.usePreloaded === 'true';
      const selectedProduct = section.dataset.selectedProduct;
      let reviews = [];
      let filtered = [];
      let shown = pageSize;

      const render = () => {
        grid.replaceChildren();
        filtered.slice(0, shown).forEach((review) => {
          const card = document.createElement('article');
          card.className = 'bd-photo-reviews__card';
          const firstMedia = Array.isArray(review.media) ? review.media[0] : null;
          if (showMedia && firstMedia) {
            const mediaData = typeof firstMedia === 'string' ? { type: 'image', url: firstMedia } : firstMedia;
            const isVideo = mediaData.type === 'video' || /\.(mp4|webm|mov)(\?|$)/i.test(mediaData.url || '');
            if (isVideo) {
              const video = document.createElement('video');
              video.className = 'bd-photo-reviews__media';
              video.controls = true;
              video.playsInline = true;
              video.preload = 'metadata';
              if (mediaData.poster) video.poster = mediaData.poster;
              video.src = mediaData.url;
              card.append(video);
            } else {
              const image = document.createElement('img');
              image.className = 'bd-photo-reviews__media';
              image.loading = 'lazy';
              image.alt = '';
              image.src = mediaData.url;
              card.append(image);
            }
          }
          const content = document.createElement('div');
          content.className = 'bd-photo-reviews__content';
          const author = document.createElement('div');
          author.className = 'bd-photo-reviews__author';
          const name = document.createElement('strong');
          name.textContent = review.name;
          author.append(name);
          if (showBadges && review.verified) {
            const verified = document.createElement('span');
            verified.className = 'bd-photo-reviews__verified';
            verified.textContent = '✓ Verified buyer';
            author.append(verified);
          }
          content.append(author);
          if (showDates && review.date) {
            const date = document.createElement('p');
            date.className = 'bd-photo-reviews__date';
            const parts = String(review.date).split('-');
            date.textContent = parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : review.date;
            content.append(date);
          }
          const stars = document.createElement('div');
          stars.className = 'bd-photo-reviews__rating';
          stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
          stars.textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
          content.append(stars);
          if (review.title) {
            const title = document.createElement('strong');
            title.textContent = review.title;
            content.append(title);
          }
          const body = document.createElement('p');
          body.className = 'bd-photo-reviews__body';
          body.textContent = review.body;
          content.append(body);
          card.append(content);
          grid.append(card);
        });
        empty.hidden = filtered.length > 0;
        loadMore.hidden = shown >= filtered.length;
      };

      try {
        let preloadedReviews = [];
        if (usePreloaded) {
          const response = await fetch(section.dataset.reviewsUrl, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Review data could not be loaded');
          const data = await response.json();
          preloadedReviews = Array.isArray(data.reviews) ? data.reviews : [];
        }
        const manualReviews = Array.isArray(manualData.reviews) ? manualData.reviews : [];
        reviews = [...preloadedReviews, ...manualReviews]
          .filter((review) => !selectedProduct || !review.product_handle || review.product_handle === selectedProduct)
          .sort((first, second) => {
            const firstHasMedia = Array.isArray(first.media) && first.media.some(Boolean);
            const secondHasMedia = Array.isArray(second.media) && second.media.some(Boolean);
            if (firstHasMedia !== secondHasMedia) return Number(secondHasMedia) - Number(firstHasMedia);
            return String(second.date || '').localeCompare(String(first.date || ''));
          });
        filtered = reviews;
        if (reviews.length) {
          const ratingAverage = reviews.reduce((sum, review) => sum + Number(review.rating || 0), 0) / reviews.length;
          const formattedAverage = ratingAverage.toFixed(1);
          average.textContent = formattedAverage;
          popupAverage.textContent = formattedAverage;
        }
        section.querySelectorAll('[data-distribution-rating]').forEach((row) => {
          const rating = Number(row.dataset.distributionRating);
          const count = reviews.filter((review) => Number(review.rating) === rating).length;
          const percent = reviews.length ? (count / reviews.length) * 100 : 0;
          row.querySelector('[data-rating-count]').textContent = String(count);
          row.querySelector('[data-rating-bar]').style.setProperty('--rating-width', `${percent}%`);
          row.setAttribute('aria-label', `${rating} stars, ${count} reviews`);
        });
        total.textContent = String(reviews.length);
        render();
      } catch (error) {
        empty.hidden = false;
        empty.textContent = 'Reviews are temporarily unavailable.';
      }

      section.querySelectorAll('[data-rating-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          section.querySelectorAll('[data-rating-filter]').forEach((item) => item.classList.remove('is-active'));
          button.classList.add('is-active');
          const rating = button.dataset.ratingFilter;
          filtered = rating === 'all' ? reviews : reviews.filter((review) => String(review.rating) === rating);
          shown = pageSize;
          render();
        });
      });
      section.querySelectorAll('[data-distribution-rating]').forEach((row) => {
        row.addEventListener('click', () => {
          const filter = section.querySelector(`[data-rating-filter="${row.dataset.distributionRating}"]`);
          if (filter) filter.click();
          ratingDetails.removeAttribute('open');
        });
      });
      loadMore.addEventListener('click', () => {
        shown += pageSize;
        render();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
